// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x6-graph-background {
    background-color: var(--mud-palette-background);
}

.x6-widget-selection-box {
    border: 2px dashed var(--mud-palette-secondary);
}

.x6-widget-selection-inner {
    border: 1px solid var(--mud-palette-secondary);
}

.elsa-snapline .x6-widget-snapline-horizontal, 
.elsa-snapline .x6-widget-snapline-vertical {
    stroke: var(--mud-palette-secondary);
}

.elsa-activity {
    border-left: solid 6px var(--mud-palette-info);
    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); 
    height: 100%;
}`, "",{"version":3,"sources":["webpack://./css/designer.css"],"names":[],"mappings":"AAAA;IACI,+CAA+C;AACnD;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,yFAAyF;IACzF,YAAY;AAChB","sourcesContent":[".x6-graph-background {\n    background-color: var(--mud-palette-background);\n}\n\n.x6-widget-selection-box {\n    border: 2px dashed var(--mud-palette-secondary);\n}\n\n.x6-widget-selection-inner {\n    border: 1px solid var(--mud-palette-secondary);\n}\n\n.elsa-snapline .x6-widget-snapline-horizontal, \n.elsa-snapline .x6-widget-snapline-vertical {\n    stroke: var(--mud-palette-secondary);\n}\n\n.elsa-activity {\n    border-left: solid 6px var(--mud-palette-info);\n    filter: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06)); \n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
